// @generated
import { PapiDeviation } from '@wix/da-papi-types';

export const filmDeviations: PapiDeviation[] = [
  {
    deviationId: 758280161,
    typeId: 1,
    url: 'https://www.deviantart.com/pikotime/art/Dave-Green-doing-his-Air-Guitar-Commission-758280161',
    title: 'Dave Green doing his Air Guitar - Commission',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-07T08:45:07-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 30487147,
      useridUuid: '996a78c1-81f2-4c01-a3b6-bee4a27f9ce9',
      username: 'pikotime',
      usericon: 'https://a.deviantart.net/avatars-big/p/i/pikotime.gif?12',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 16,
      favourites: 31,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/PpHJVRFZ5ChF9jLScB2IqAYX5AQ=/fit-in/150x150/filters:no_upscale():origin()/other00/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 113,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/DZwi7A1JrEXNP6dPtHN_NuHPU4s=/300x200/filters:fixed_height(100,100):origin()/other00/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 200,
          w: 267,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/aRqMNpz_LsKNGL54dybiU-pgPGw=/fit-in/300x900/filters:no_upscale():origin()/other00/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 225,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/4-UM7_nacWTC-dWixb8Wz1k9hIk=/500x250/filters:fixed_height(100,100):origin()/other00/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 250,
          w: 333,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/MxrgYyNr0sNxxY0a0tcCLh7KJLc=/700x350/filters:fixed_height(100,100):origin()/other00/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 350,
          w: 467,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/lCAjnZxFnaxa7XNf478UEQ32i2U=/800x400/filters:fixed_height(100,100):origin()/other00/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 400,
          w: 533,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 1080,
          w: 1440,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 1080,
          w: 1440,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/abed/o/2018/219/1/9/19e34415039790d8e21538f95c6ecf15.jpg',
          h: 1080,
          w: 1440,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/9d0f/v/mp4/2018/219/7/7/air_guit_final_mp4_by_pikotime-dcjgkpt.mp4',
          h: 360,
          w: 480,
          q: '360p',
          f: 320401,
          d: 7,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/870e/v/mp4/2018/219/3/9/air_guit_final_mp4_by_pikotime-dcjgkpt.mp4',
          h: 720,
          w: 960,
          q: '720p',
          f: 629998,
          d: 7,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/f34a/v/mp4/2018/219/f/8/air_guit_final_mp4_by_pikotime-dcjgkpt.mp4',
          h: 1080,
          w: 1440,
          q: '1080p',
          f: 981790,
          d: 7,
        },
      ],
    },
  },
  {
    deviationId: 757297740,
    typeId: 1,
    url: 'https://www.deviantart.com/zarashi99/art/LHR-Pudding-Hunt-Dev-Test-Gameplay-757297740',
    title: '[LHR: Pudding Hunt] Dev Test Gameplay',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-07-31T23:44:27-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 19141997,
      useridUuid: '08a50655-d954-462d-a65a-4fb5d8df66ad',
      username: 'Zarashi99',
      usericon: 'https://a.deviantart.net/avatars-big/z/a/zarashi99.png?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 19,
      favourites: 9,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/Owvfx4Tg7QwGJR0kFz2TeT-Y1oY=/fit-in/150x150/filters:no_upscale():origin()/other00/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 93,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/qupVZ6t9hall5hA-xOP1F26_ydg=/300x200/filters:fixed_height(100,100):origin()/other00/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 186,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/ktMSDzeQ7TW0LSCJgvzEdJLiyO4=/fit-in/300x900/filters:no_upscale():origin()/other00/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 186,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/P2OhE8QeC3Jv16HengHp2V85HE8=/500x250/filters:fixed_height(100,100):origin()/other00/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 250,
          w: 404,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/Rq7oV3BgrlCMl5cy8DjBAEElUQ0=/700x350/filters:fixed_height(100,100):origin()/other00/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 350,
          w: 566,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/XTp4OEd0MIU_H2UWpdCfAhLFS0w=/800x400/filters:fixed_height(100,100):origin()/other00/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 400,
          w: 647,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 720,
          w: 1164,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 720,
          w: 1164,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/705c/o/2018/212/4/a/4ab7caebf9bcfdaa3eb7862e27629435.jpg',
          h: 720,
          w: 1164,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/ecbc/v/mp4/2018/212/2/d/lhr_dev_test_gameplay_by_zarashi99-dcivioc.mp4',
          h: 360,
          w: 582,
          q: '360p',
          f: 3931006,
          d: 105,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/5ac0/v/mp4/2018/212/f/7/lhr_dev_test_gameplay_by_zarashi99-dcivioc.mp4',
          h: 720,
          w: 1164,
          q: '720p',
          f: 8936434,
          d: 105,
        },
      ],
    },
  },
  {
    deviationId: 757012963,
    typeId: 1,
    url: 'https://www.deviantart.com/booublik/art/Nordwort-The-Good-End-757012963',
    title: 'Nordwort: The Good End',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-07-30T08:59:33-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 44665214,
      useridUuid: '3f24b36e-5c5b-4d31-80a0-3229fb8160f1',
      username: 'booublik',
      usericon: 'https://a.deviantart.net/avatars-big/b/o/booublik.jpg?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 11,
      favourites: 33,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/QVzUQAgIyiiuU4pmv2sKMT-y7Qw=/fit-in/150x150/filters:no_upscale():origin()/other00/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/iBl09cZkLqme37ILnct_bUE0pUc=/300x200/filters:fixed_height(100,100):origin()/other00/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/Pr1LsmIi1nQnRu44m7O2IjtyWfg=/fit-in/300x900/filters:no_upscale():origin()/other00/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/tJwQxqoMOG6ik260rVANYD3kKlQ=/500x250/filters:fixed_height(100,100):origin()/other00/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/wzQ6cn-yhwd8pU3sEGx2b_33DuE=/700x350/filters:fixed_height(100,100):origin()/other00/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/xpVaEOZi3qINIpVS0xvK4Ls2RDU=/800x400/filters:fixed_height(100,100):origin()/other00/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/979d/o/2018/211/4/7/47feeb27dcebed612fd5ce5e7e11a658.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/9d55/v/mp4/2018/211/7/8/_40__by_booublik-dcipexv.mp4',
          h: 360,
          w: 640,
          q: '360p',
          f: 4715194,
          d: 46,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/27da/v/mp4/2018/211/8/6/_40__by_booublik-dcipexv.mp4',
          h: 720,
          w: 1280,
          q: '720p',
          f: 11688248,
          d: 46,
        },
      ],
    },
  },
  {
    deviationId: 759273516,
    typeId: 1,
    url: 'https://www.deviantart.com/latyprod/art/Undertale-Sans-Judgment-Hall-3d-Animation-759273516',
    title: '[Undertale] Sans/Judgment Hall 3d (Animation)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-13T12:39:05-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 11636654,
      useridUuid: '9cec4e87-d742-4114-9553-dee85a61b58b',
      username: 'Latyprod',
      usericon: 'https://a.deviantart.net/avatars-big/l/a/latyprod.jpg?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 3,
      favourites: 24,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/75FQ4ykiPF6IEpHlOPJ2aw15FP4=/fit-in/150x150/filters:no_upscale():origin()/other00/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 79,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/cix7-Uv0GRS5Hp24XJkYpu0eDbA=/300x200/filters:fixed_height(100,100):origin()/other00/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 158,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/2V-ghNeP25k0e9tOnwtMwuJ6Fek=/fit-in/300x900/filters:no_upscale():origin()/other00/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 158,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/qRL9lhRr-X51zDK0chuc4s_awN0=/500x250/filters:fixed_height(100,100):origin()/other00/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 250,
          w: 474,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/m29drzbSKUs394Q7D9kyRuctyog=/700x350/filters:fixed_height(100,100):origin()/other00/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 350,
          w: 664,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/uivL2rBGWXsLRFqGlVUiHZ8HfRI=/800x400/filters:fixed_height(100,100):origin()/other00/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 400,
          w: 759,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 1012,
          w: 1920,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 1012,
          w: 1920,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/86f8/o/2018/225/1/8/18e813771677b0bdd28e68363f7b08aa.jpg',
          h: 1012,
          w: 1920,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/2fc0/v/mp4/2018/225/1/6/sans_eevee_notext_by_latyprod-dck1v70.mp4',
          h: 360,
          w: 682,
          q: '360p',
          f: 895928,
          d: 10,
        },
      ],
    },
  },
  {
    deviationId: 758977603,
    typeId: 1,
    url: 'https://www.deviantart.com/bughs-22/art/MUSIC-ChemicalWorld-758977603',
    title: 'MUSIC - ChemicalWorld',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-11T14:34:50-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 30855454,
      useridUuid: '68c38b2b-afdf-445b-bb14-557b38f39458',
      username: 'BUGHS-22',
      usericon: 'https://a.deviantart.net/avatars-big/b/u/bughs-22.png?7',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 17,
      favourites: 42,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/8zvimCKR40GNLyweAgyhkR4Yy8o=/fit-in/150x150/filters:no_upscale():origin()/other00/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/TcwkW8G7vhNel7QdW8gvJy3kobw=/300x200/filters:fixed_height(100,100):origin()/other00/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/DPIscC8BYCYDlE42_qbEJpD5MNU=/fit-in/300x900/filters:no_upscale():origin()/other00/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/5M2Pba18gWBH2C2ztlmQczWEIec=/500x250/filters:fixed_height(100,100):origin()/other00/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 250,
          w: 445,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/uMdYQsElrAFuapbKCgAE0uxdBxs=/700x350/filters:fixed_height(100,100):origin()/other00/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 350,
          w: 623,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/GHctJk1gr07RVoN453liKv2Qb04=/800x400/filters:fixed_height(100,100):origin()/other00/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 400,
          w: 712,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 480,
          w: 854,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 480,
          w: 854,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/50ce/o/2018/223/f/8/f82abb80ffd488a142f6a9f34c8a267b.jpg',
          h: 480,
          w: 854,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/c4be/v/mp4/2018/223/1/0/chemicalworld_by_bughs_22-dcjviv7.mp4',
          h: 360,
          w: 640,
          q: '360p',
          f: 2768641,
          d: 140,
        },
      ],
    },
  },
  {
    deviationId: 757554848,
    typeId: 1,
    url: 'https://www.deviantart.com/erictonarts/art/Pushing-Against-Frustration-animated-757554848',
    title: 'Pushing Against Frustration (animated)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-02T18:40:17-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 12172003,
      useridUuid: 'c33ed37b-da24-4e90-8b78-fd3cc9325e6d',
      username: 'EricTonArts',
      usericon: 'https://a.deviantart.net/avatars-big/e/r/erictonarts.jpg?7',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 2,
      favourites: 7,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/HRFK5DUkajhaFosPWVuhnTGpQqM=/fit-in/150x150/filters:no_upscale():origin()/other00/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 150,
          w: 114,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/aV3zsAxW1Juepp06NxQryy67OVE=/300x200/filters:fixed_height(100,100):origin()/other00/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 200,
          w: 152,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/iSsqEYhPTaxR1HbeklWOtG8kjFo=/fit-in/300x900/filters:no_upscale():origin()/other00/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 394,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/Hzb3YYimEHiekq7J4G5rIoISu8I=/500x250/filters:fixed_height(100,100):origin()/other00/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 250,
          w: 190,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/3Mjv8gGshrAs2MuMWX9zWFxZBh0=/700x350/filters:fixed_height(100,100):origin()/other00/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 350,
          w: 266,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/sKKe4Gf9NdPi6rWwXokEnHg0VNE=/800x400/filters:fixed_height(100,100):origin()/other00/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 400,
          w: 304,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 752,
          w: 572,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 752,
          w: 572,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/06e3/o/2018/214/2/c/2c8be526752a61502b1fa010e7b32c2b.jpg',
          h: 752,
          w: 572,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/cfd8/v/mp4/2018/214/4/d/pres1_by_erictonarts-dcj1128.mp4',
          h: 360,
          w: 274,
          q: '360p',
          f: 2228395,
          d: 20,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/0d16/v/mp4/2018/214/a/2/pres1_by_erictonarts-dcj1128.mp4',
          h: 720,
          w: 548,
          q: '720p',
          f: 7114377,
          d: 20,
        },
      ],
    },
  },
  {
    deviationId: 756143204,
    typeId: 1,
    url: 'https://www.deviantart.com/atrox-c/art/Dover-Boys-Re-Animated-Collab-Shot-044-756143204',
    title: 'Dover Boys Re-Animated Collab - Shot 044',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-07-24T17:45:50-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1806646,
      useridUuid: '913fb7f7-d67d-4fe4-9b3b-a5835df0f8e8',
      username: 'Atrox-C',
      usericon: 'https://a.deviantart.net/avatars-big/a/t/atrox-c.png?9',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 40,
      favourites: 214,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/xgmVj2sGf62E8EHJS70TmutQKTE=/fit-in/150x150/filters:no_upscale():origin()/other00/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/4x5MnQ8yqrBs0zrpJQUEXFCpsEo=/300x200/filters:fixed_height(100,100):origin()/other00/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/cI9A3_3BpFZLIr2UGPANwk0Aazg=/fit-in/300x900/filters:no_upscale():origin()/other00/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/jGbEjov0-js9NWpyWcsin2mRLI0=/500x250/filters:fixed_height(100,100):origin()/other00/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/rgB-KfZPV6EE1ZAJVeHLH3OGvyA=/700x350/filters:fixed_height(100,100):origin()/other00/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/pqy8Ec31ZcsKAbCrnWYT4-p0x2E=/800x400/filters:fixed_height(100,100):origin()/other00/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 1080,
          w: 1920,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 1080,
          w: 1920,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/3f38/o/2018/205/b/a/babbe53b9eaf831ebb8cec2e7c426a5d.jpg',
          h: 1080,
          w: 1920,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/d39c/v/mp4/2018/205/6/1/tdb044_atrox_hd_by_atrox_c-dci6rtw.mp4',
          h: 360,
          w: 640,
          q: '360p',
          f: 819007,
          d: 7,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/e875/v/mp4/2018/205/0/f/tdb044_atrox_hd_by_atrox_c-dci6rtw.mp4',
          h: 720,
          w: 1280,
          q: '720p',
          f: 1904947,
          d: 7,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/a006/v/mp4/2018/205/7/4/tdb044_atrox_hd_by_atrox_c-dci6rtw.mp4',
          h: 1080,
          w: 1920,
          q: '1080p',
          f: 3093458,
          d: 7,
        },
      ],
    },
  },
  {
    deviationId: 759429344,
    typeId: 1,
    url: 'https://www.deviantart.com/sykosan/art/Rush-759429344',
    title: 'Rush',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-14T12:46:48-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 5538532,
      useridUuid: 'd8992206-afdf-459a-80d7-a66541d35c18',
      username: 'sykosan',
      usericon: 'https://a.deviantart.net/avatars-big/s/y/sykosan.png?13',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 2,
      favourites: 81,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/liY_CTmsBIbI_iSJ-slddkk8FrA=/fit-in/150x150/filters:no_upscale():origin()/other00/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/G7QXPd3Z6ijfN2w4YfZIp20dEa8=/300x200/filters:fixed_height(100,100):origin()/other00/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/LzWM0ezQ5rud59dAU1ZgAfi8aWM=/fit-in/300x900/filters:no_upscale():origin()/other00/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/bV1vqg53tFPrltoex-KfN6oUKlU=/500x250/filters:fixed_height(100,100):origin()/other00/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/gFVfw07w6dYGLgWdU9DBavkWWKw=/700x350/filters:fixed_height(100,100):origin()/other00/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/lloSzObVNJMShrifrd7Z56pUYaA=/800x400/filters:fixed_height(100,100):origin()/other00/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/459f/o/2018/226/2/8/28788761a9e664ecd770c48bf00513cf.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/2b18/v/mp4/2018/226/5/4/rush_web_by_sykosan-dck57fk.mp4',
          h: 360,
          w: 640,
          q: '360p',
          f: 1460497,
          d: 18,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/b6c4/v/mp4/2018/226/f/2/rush_web_by_sykosan-dck57fk.mp4',
          h: 720,
          w: 1280,
          q: '720p',
          f: 3784977,
          d: 18,
        },
      ],
    },
  },
  {
    deviationId: 760583765,
    typeId: 1,
    url: 'https://www.deviantart.com/paradigm-shifting/art/Jackson-Palmer-What-is-Holochain-760583765',
    title: 'Jackson Palmer: What is Holochain?',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-22T01:12:26-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1548442,
      useridUuid: 'a8b5e48f-7e36-433b-8081-851157dd7cfc',
      username: 'paradigm-shifting',
      usericon:
        'https://a.deviantart.net/avatars-big/p/a/paradigm-shifting.png?6',
      type: 'beta',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 3,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/IuGDX-FH3uPXqKeoqap2yPOeR9c=/fit-in/150x150/filters:no_upscale():origin()/other00/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/0vCdsYWBFceev2jG6jjehcwffRY=/300x200/filters:fixed_height(100,100):origin()/other00/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/LOtOv6QAaj5_BJzsyv7Ct89UHjA=/fit-in/300x900/filters:no_upscale():origin()/other00/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/oWzFRQ1dyseE8o0nhmttaDejX14=/500x250/filters:fixed_height(100,100):origin()/other00/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/8kn8N6zHdayAWwlZ9gadz-7tpVM=/700x350/filters:fixed_height(100,100):origin()/other00/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/NQ7iRIfdve1LeNp-KCsjhwx6Eew=/800x400/filters:fixed_height(100,100):origin()/other00/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/d284/o/2018/234/9/5/9587d45126f795d4d86ae2db77e50c9c.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/5f80/v/mp4/2018/234/8/7/1234_720p_by_paradigm_shifting-dckty6t.mp4',
          h: 360,
          w: 640,
          q: '360p',
          f: 36708066,
          d: 713,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/9de1/v/mp4/2018/234/7/f/1234_720p_by_paradigm_shifting-dckty6t.mp4',
          h: 720,
          w: 1280,
          q: '720p',
          f: 74851203,
          d: 713,
        },
      ],
    },
  },
  {
    deviationId: 759721366,
    typeId: 1,
    url: 'https://www.deviantart.com/mother3flint/art/Episode-4-Broken-things-759721366',
    title: 'Episode 4 - Broken things',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-22T13:41:08-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 6393089,
      useridUuid: '1d7e36fe-dcd0-4d60-8615-48f57fc8a77c',
      username: 'mother3Flint',
      usericon: 'https://a.deviantart.net/avatars-big/m/o/mother3flint.png?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 7,
      favourites: 6,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/GyX9w8jJ158_dGeF-Gk5dtQghKE=/fit-in/150x150/filters:no_upscale():origin()/other00/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/zBMs9Rz0a5RRLB_ZsXrmK10bHKA=/300x200/filters:fixed_height(100,100):origin()/other00/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/6sBxPngSh2EC8GawbgrP4I_9gaM=/fit-in/300x900/filters:no_upscale():origin()/other00/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/OvRJclYSNs7KAoLWy-vwvbYW3Kk=/500x250/filters:fixed_height(100,100):origin()/other00/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/Vl6ae51AdoF6kY692ALvVkHMRDM=/700x350/filters:fixed_height(100,100):origin()/other00/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/1qMFPHYSpmnLOibTh7zk_qUJITY=/800x400/filters:fixed_height(100,100):origin()/other00/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/ea53/o/2018/228/d/5/d5b8c3f5c5326aeb7a8802946b97a6c2.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/6fa2/v/mp4/2018/228/b/b/ingles_by_mother3flint-dckbgra.mp4',
          h: 360,
          w: 640,
          q: '360p',
          f: 19857768,
          d: 607,
        },
      ],
    },
  },
  {
    deviationId: 748500767,
    typeId: 1,
    url: 'https://www.deviantart.com/mother3flint/art/Etyani-X-748500767',
    title: 'Etyani X.',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-22T13:33:09-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 6393089,
      useridUuid: '1d7e36fe-dcd0-4d60-8615-48f57fc8a77c',
      username: 'mother3Flint',
      usericon: 'https://a.deviantart.net/avatars-big/m/o/mother3flint.png?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 3,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/xiwV7D1kPqkDMDcX8F90BdujnGA=/fit-in/150x150/filters:no_upscale():origin()/other00/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/-afp9VCjLuu7wRtNdh6We-LGu6M=/300x200/filters:fixed_height(100,100):origin()/other00/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/azlnxGX7BVS5Za4t41GXNYFAURY=/fit-in/300x900/filters:no_upscale():origin()/other00/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/vBZYJkYQtTjeXrSWXN94DbMi9TU=/500x250/filters:fixed_height(100,100):origin()/other00/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/MCBEgy6RT2RiskbssDJiHAsp9y4=/700x350/filters:fixed_height(100,100):origin()/other00/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/LSwPRl8NBwuRaumsGUuxjWBxcRI=/800x400/filters:fixed_height(100,100):origin()/other00/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/ca07/o/2018/157/d/8/d8b60023b0f441fdb3f77703577ad87d.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/a72e/v/mp4/2018/157/1/7/etyani_720_by_mother3flint-dcdmyvz.mp4',
          h: 360,
          w: 640,
          q: '360p',
          f: 4586409,
          d: 76,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/bbda/v/mp4/2018/157/9/b/etyani_720_by_mother3flint-dcdmyvz.mp4',
          h: 720,
          w: 1280,
          q: '720p',
          f: 8908930,
          d: 76,
        },
      ],
    },
  },
  {
    deviationId: 760606969,
    typeId: 1,
    url: 'https://www.deviantart.com/paradigm-shifting/art/1947-Don-t-Be-A-Sucker-Full-National-Archive-V-760606969',
    title: "[1947] Don't Be A Sucker - Full National Archive V",
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-22T06:52:44-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1548442,
      useridUuid: 'a8b5e48f-7e36-433b-8081-851157dd7cfc',
      username: 'paradigm-shifting',
      usericon:
        'https://a.deviantart.net/avatars-big/p/a/paradigm-shifting.png?6',
      type: 'beta',
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 7,
    },
    media: {
      types: [
        {
          t: '150',
          r: -2,
          s: 'https://t00.deviantart.net/Q5mqiFfhO_o5VwzZ8fQQOP3Qc4o=/fit-in/150x150/filters:no_upscale():origin()/other00/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -2,
          s: 'https://t00.deviantart.net/5gvG4mf5P6G__UXvimUzHdhwDZw=/300x200/filters:fixed_height(100,100):origin()/other00/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -2,
          s: 'https://t00.deviantart.net/p4iiFn_YLTfl7bneq8-dvkP34KI=/fit-in/300x900/filters:no_upscale():origin()/other00/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -2,
          s: 'https://t00.deviantart.net/uqR1mFWx5XH5J2NYCIpA8D0wmUo=/500x250/filters:fixed_height(100,100):origin()/other00/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: -2,
          s: 'https://t00.deviantart.net/vd7rqfrdQ9uXD-Et21heF5A1hYw=/700x350/filters:fixed_height(100,100):origin()/other00/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: -2,
          s: 'https://t00.deviantart.net/YV1oFF_MpctZEJdXyu3yPjRoZ4k=/800x400/filters:fixed_height(100,100):origin()/other00/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: -2,
          s: 'https://other00.deviantart.net/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'social_preview',
          r: -2,
          s: 'https://other00.deviantart.net/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'fullview',
          r: -2,
          s: 'https://other00.deviantart.net/4ebb/o/2018/234/5/1/512ed61113ebcb820e9961f5db538689.jpg',
          h: 720,
          w: 1280,
        },
        {
          t: 'video',
          r: -2,
          s: 'https://film00.deviantart.net/ecf9/v/mp4/2018/234/2/a/1234_720p_by_paradigm_shifting-dckug3d.mp4',
          h: 360,
          w: 640,
          q: '360p',
          f: 103053351,
          d: 1370,
        },
      ],
    },
  },
];
